import { Box, Button } from '@material-ui/core';
import { sortBy } from 'lodash';
import { useObserver } from 'mobx-react';
import React, { useState } from 'react';
import { FBInput, FBProvider } from '..';
import { translate } from '../../../common/intl';
import FBDeviationMpiSection from './FBDeviationMpiSection';
import useDeviationProcedureStyles from './FBDeviationProcedure.styles';
import { FBDeviationProcedureProps } from './FBDeviationProcedure.types';
import { withFBDeviationProcedure } from './FBDeviationProcedure.wrap';

const FBDeviationProcedure: React.FC<FBDeviationProcedureProps> = ({
  deviationProcedureState,
  name,
  disabled,
  isPreview,
  isOutput,
  editorConfig,
  canEdit,
  ...props
}) => {
  const classes = useDeviationProcedureStyles();
  // saved config is jsonb, which doesn't keep key order: show the LHR steps in the LHRT's order
  const mpiEntries = useObserver(() => sortBy(
    Object.entries(deviationProcedureState?.editorConfig ?? editorConfig ?? {}),
    ([, steps]) => (Object.values(steps ?? {})[0] as { mpiIndex?: number } | undefined)?.mpiIndex ?? Infinity,
  ));
  const [expandedIds, setExpandedIds] = useState<string[]>([]);
  const allExpanded = mpiEntries.length > 0 && mpiEntries.every(([mpiId]) => expandedIds.includes(mpiId));
  const toggleAll = () => setExpandedIds(allExpanded ? [] : mpiEntries.map(([mpiId]) => mpiId));
  const toggle = (mpiId: string) => setExpandedIds((ids) =>
    (ids.includes(mpiId) ? ids.filter((id) => id !== mpiId) : [...ids, mpiId]));

  return (
    <Box className={classes.root}>
      <FBInput
        {...props}
        {...{ name }}
        type="deviationprocedure"
        shouldWrapWithFormControl={false}
      >
        {mpiEntries.length > 0 && (
          <Button variant="text" disableRipple className={classes.expandAllButton} onClick={toggleAll}>
            {translate(allExpanded ? 'common.collapse.all' : 'common.expand.all')}
          </Button>
        )}
        <FBProvider deviationProcedureState={deviationProcedureState}>
          {mpiEntries.map(([mpiId, steps], index) => (
            <FBDeviationMpiSection
              key={mpiId}
              mpiId={mpiId}
              mpiIndex={index + 1}
              steps={steps}
              {...{ name: name ?? '', disabled, isPreview, isOutput, canEdit }}
              deviationProcedureState={deviationProcedureState}
              expanded={expandedIds.includes(mpiId)}
              onToggle={() => toggle(mpiId)}
            />
          ))}
        </FBProvider>
      </FBInput>
    </Box>
  );
};

export default withFBDeviationProcedure(FBDeviationProcedure);
